"use client"

import { type PropsWithChildren } from "react"

import { useGridLayoutContext } from "~/providers/GridLayoutProvider/index.client"

import * as css from "./styles.css"

export function GridLayout({ children }: PropsWithChildren) {
  const { layout } = useGridLayoutContext()

  return <div className={css.gridLayout({ size: layout })}>{children}</div>
}
